import React, { useState, useEffect, useMemo } from 'react'
import classes from './myClasses.module.css'
import gridClasses from '../../../styles/grid.module.css'
import Footer from '../../../components/Footer/Footer'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import ToggleBar from '../../../components/ToggleBar/ToggleBar'
import { ClassCard } from '../../../components/Cards/GeneralCard/Card'
import { AuthenticatedHeader } from '../../../components/Header/AuthenticatedHeader'
import { useSelector, useDispatch } from 'react-redux'
import { userClassesSelectors } from './userClassesSlice'
import CardLoader from '../../../components/loaders/CardLoader'
import notification from '../../../components/Notification/notification'
import { getImageURL, getParentRoute } from '../../../util/functions'
import { getUserClasses } from './userClassesApi'
import Empty from '../../../components/Empty/Empty'
import emptyClassImage from '../../../assets/images/empty-class.svg'

const MyClasses = ({ location }) => {
    const dispatch = useDispatch()

    const isFetching = useSelector(userClassesSelectors.isFetching)
    const hasError = useSelector(userClassesSelectors.hasError)
    const errorMessage = useSelector(userClassesSelectors.errorMessage)
    const userClasses = useSelector(userClassesSelectors.classes)
    const categories = useSelector(userClassesSelectors.categories)

    const [activeLink, setActiveLink] = useState('all')

    const toggleLinks = useMemo(
        () => [
            {
                text: 'All',
                active: activeLink === 'all',
                id: 'all',
            },
            {
                text: 'Ongoing',
                active: activeLink === 'ongoing',
                badge: {
                    variant: 'blue',
                    text: categories.ongoing.length,
                },
                id: 'ongoing',
            },
            {
                text: 'Upcoming',
                active: activeLink === 'upcoming',
                id: 'upcoming',
            },
            {
                text: 'Completed',
                active: activeLink === 'completed',
                id: 'completed',
            },
        ],
        [activeLink, categories.ongoing]
    )

    const activeCategoryId = activeLink
    const activeCategoryItems = categories[activeCategoryId].map(
        id => userClasses[id]
    )

    useEffect(() => {
        if (hasError)
            notification.failure({
                title: 'Failed to fetch your classes',
                description: errorMessage,
            })
    }, [hasError, errorMessage])

    useEffect(() => {
        dispatch(getUserClasses())
    }, [dispatch])

    const parentRoute = getParentRoute(location.pathname)

    let emptyMessage = "You haven't enrolled for any classes."

    if (activeCategoryId === 'ongoing')
        emptyMessage = 'You have no ongoing classes.'

    if (activeCategoryId === 'completed')
        emptyMessage = 'Yoo have no completed classes'

    if (activeCategoryId === 'upcoming')
        emptyMessage = 'You have no upcoming classes'

    return (
        <>
            <AuthenticatedHeader />
            <main className={classes.main}>
                <div className={classes.topLinks}>
                    <div
                        className={classNames(
                            gridClasses.container,
                            classes.topLinksContainer
                        )}
                    >
                        <Link
                            to={`${parentRoute}/my-courses`}
                            className={classes.topLink}
                        >
                            My Courses
                        </Link>
                        <Link
                            to={`${parentRoute}/my-classes`}
                            className={classNames(
                                classes.topLink,
                                classes.topLinkActive
                            )}
                        >
                            My Classes
                        </Link>
                    </div>
                </div>
                <div
                    className={classNames(
                        gridClasses.container,
                        classes.toggleBarWrapper
                    )}
                >
                    <ToggleBar
                        links={toggleLinks}
                        changeActive={setActiveLink}
                        activeId={activeLink}
                    />
                </div>
                <div className={gridClasses.container}>
                    <div className={classes.cardsGrid}>
                        {isFetching &&
                            [1, 2, 3].map(id => <CardLoader key={id} />)}
                        {activeCategoryItems.map((classData, index) => (
                            <ClassCard
                                {...classData}
                                url={
                                    getImageURL(classData.thumbnail) ||
                                    require('../../../assets/images/class-placeholder.svg')
                                }
                                key={index}
                                className={classes.card}
                                date={classData.startdate}
                                time={classData.starttime}
                            />
                        ))}
                    </div>
                    {activeCategoryItems.length === 0 && !isFetching && (
                        <Empty icon={emptyClassImage} text={emptyMessage} />
                    )}
                </div>
            </main>
            <Footer />
        </>
    )
}

export default MyClasses
